<template>
  <div class="bg-white max-w-lg my-4">
    <a-list bordered :data-source="referenceIndexes">
      <h3 slot="header" class="text-xl font-semibold">
        REFERENCE INDEXES
        <div class="float-right cursor-pointer" @click="notifyAddButtonClick()">
          <font-awesome-icon icon="plus"></font-awesome-icon>
        </div>
      </h3>
      <a-list-item slot="renderItem" slot-scope="item">
        <div class="w-full">
          <span
            class="cursor-pointer text-terracotta hover:underline"
            @click="notifyEditButtonClick(item)"
          >
            {{ item.name }}
          </span>
          <a-popconfirm
            title="Are you sure you want to delete this index?"
            ok-text="Yes"
            cancel-text="No"
            @confirm="notifyDeleteButtonClick(item.id)"
          >
            <a-icon
              type="delete"
              title="Delete"
              class="mx-2 float-right cursor-pointer text-red-400"
            ></a-icon>
          </a-popconfirm>
          <a-icon
            type="edit"
            title="Edit"
            class="mx-2 float-right cursor-pointer text-terracotta"
            @click="notifyEditButtonClick(item)"
          ></a-icon>
        </div>
      </a-list-item>
    </a-list>
  </div>
</template>

<script>
export default {
  props: {
    referenceIndexes: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    notifyAddButtonClick() {
      this.$emit('add-reference-index')
    },
    notifyDeleteButtonClick(indexId) {
      this.$emit('delete-reference-index', indexId)
    },
    notifyEditButtonClick(index) {
      this.$emit('edit-reference-index', index)
    },
  },
}
</script>

<style></style>
